<template>
  <div class="start flex flex-wrap -mx-2">
    <div v-if="ready" class="w-full">
      <div class="bg-red-lightest border border-red-light text-red-dark px-4 my-2 py-3 rounded relative" role="alert">
        <strong class="font-bold">Oh no!</strong>
        <span class="block sm:inline">Die gewählte Seite konnte nicht gefunden werden<br />{{ $route.params }}</span>
        <router-link tag="a" :to="{ path: '/' }" class="block text-orange-dark pt-2">zur Startseite</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import endpoints from '../../endpoints'

export default {
  name: 'PageNotFound',

  data () {
    return {
      ready: false,
      hostId: window.hostId
    }
  },

  created () {
    const url = this.$route.path.replace('/', '')

    axios.post(endpoints.gethostbyurl, { url: url })
      .then(response => {
        if (response.data.id) {
          this.$router.push({ name: 'Shop', params: { hostUrl: url } })
        }

        this.ready = true
      })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/errors/404-not-found.vue